import { supabase } from "@/lib/supabase";
import {
  File,
  FileText,
  FileImage,
  FileVideo,
  FileArchive,
  FileSpreadsheet,
  FileCode,
} from "lucide-react";

function getFileIcon(ext: string | undefined) {
  switch (ext) {
    case "pdf":
      return <FileText />;
    case "jpg":
    case "jpeg":
    case "png":
    case "gif":
      return <FileImage />;
    case "mp4":
    case "mov":
      return <FileVideo />;
    case "zip":
    case "rar":
      return <FileArchive />;
    case "xls":
    case "xlsx":
      return <FileSpreadsheet />;
    case "txt":
    case "md":
      return <FileText />;
    case "js":
    case "ts":
    case "html":
    case "css":
      return <FileCode />;
    default:
      return <File />;
  }
}

export function FilePreview({ url }: { url?: string }) {
  if (!url) return null;

  const ext = url.split(".").pop()?.toLowerCase();
  const icon = getFileIcon(ext);

  const getImage = async (url: string) => {
    if (!url) return "";
    let uploadedUrl: any = null;

    const { data: signedData, error: signedError } = await supabase.storage
      .from("attachments")
      .createSignedUrl(url, 60 * 60 * 24 * 7);

    if (!signedError && signedData?.signedUrl) {
      uploadedUrl = signedData.signedUrl;
    }
    window.open(uploadedUrl);
    return uploadedUrl;
  };
  return (
    <a
      onClick={() => getImage(url)}
      rel="noopener noreferrer"
      className="inline-flex items-center gap-1 text-primary hover:underline"
    >
      {icon}
      <span className="text-sm"> </span>
    </a>
  );
}
